// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Data Mall",
        pull_refresh: 'Ciągnąć, aby odświeżyć',
        release_refresh: 'Zwolnij, aby odświeżyć',
        refresh_loading: 'Załadunek…',
        footer_text: 'Usługi świadczone przez Ucloudlink (NASDAQ: UCL)'
      },
      home: {
        input_placeholder: 'Kraj przeszukania/region',
        my_flow: 'Moje dane',
        charge_code: 'Kod kuponu',
        coupons: 'Kupony',
        local_package: 'Dane lokalne',
        more: 'Więcej',
        popular_destination: 'Kraj/region',
        buy_now: 'Kup teraz',
        package_useing: 'Aktywny',
        unused: 'Nieaktywny',
        download_app: 'Pobierz aplikację',
        enter_the_mall_list: 'Wejdź do listy sklepów',
        no_data: 'Brak danych',
        no_data_available: "Brak dostępnych danych",
        copy_success: 'Skopiowano pomyślnie',
        copy_fail: 'Kopiowanie nie powiodło się',
        meritsTitle: 'Jakie są zalety?',
        merits1: 'Bez karty SIM & Bez opłat miesięcznych',
        merits2: 'Zintegrowane z topowymi 2-3 operatorami do automatycznego przełączania sieci',
        go_buy: 'Kup teraz',
        instant_savings: 'Oszczędź',
        expires_in: 'Wygasa za',
        download_app_tips: "Pobierz aplikację, aby uzyskać więcej ofert i wrażeń"
      },
      packages: {
        sub_title: {
          us: 'Z wyłączeniem Guam, Saipan',
          it: 'W tym Vatican City, San Marino',
          va: 'W tym Włochy, San Marino',
          sm: 'W tym Włochy, miasto Watykanu',
          ma: 'W tym Sahara Zachodnia',
          eh: 'W tym Maroko',
          ch: 'W tym Liechtenstein',
          li: 'W tym Szwajcaria',
          fr: 'W tym Monako',
          mc: 'W tym Francja',
          fi: 'W tym wyspy Aland',
          ax: 'W tym Finlandia',
          gu: 'W tym północne wyspy Mariany',
          mp: 'W tym Guam'
        },
        unlimited_packages: 'Nieograniczony pakiet danych',
        normal_packages: 'Normalny pakiet danych',
        multi_region_packages: 'Multiregion',
        regional_data: 'Dane regionalne',
        high_speed_text: 'Dane o dużej prędkości',
        infiniteFlow: 'Nieograniczone dane',
        unLimitData: 'Bezlimity',
        high_speed_text_year: 'duża prędkość/MP',
        package_list: 'Lista pakietów',
        special_offer: 'Promocje',
        first_month: '1. Miesiąc',
        periodUnit: {
          day: 'dni)',
          month: 'miesiąc',
          hour: 'godziny (s)',
          year: 'rok',
        },
        periodUnits: {
          day: 'dni)',
          month: 'miesiące',
          hour: 'godziny (s)',
          year: 'lata',
        },
        periodUnitSimp: {
          day: 'D',
          month: 'mo',
          hour: 'H',
          year: 'rok'
        },
        periodUnitMonthly:'Miesięczny',
        periodUnitsSimp: {
          day: 'D',
          month: 'mo',
          hour: 'H',
          year: 'rok'
        },
        unlimited_good_name: {
          day: 'Przepustka dzienna',
          month: 'Bilet miesięczny',
          year: 'Roczna przepustka'
        },
        continuousMonth: "Miesiące ciągłe",
        continuousDay: "Ciągłe dni",
        continuousYear: "Ciągłe lata",
        
        day_invalid: 'Wygasa w bieżącym dniu',
        month_invalid: 'Wygasa w bieżącym miesiącu',
        immediate_valid: 'Skuteczne natychmiast',
        tomorrow_day_valid: 'Skuteczne od następnego dnia',
        tomorrow_month_valid: 'Obowiązuje od następnego miesiąca',
    
        // detail page
        detail: {
          cell_flow: 'Dane',
          cell_period: 'Ważność',
          buy_quantity: 'Kwota',
          use_area: 'Zasięg',
          use_intro: 'Warunki',
          buy_btn: 'Zamówienie',
          pay: 'Zapłacić',
          buy_tips: 'Masz pakiet %@packageName w użyciu. Czy chcesz kupić ten pakiet?',
          haveOrderTips: "Utworzono zamówienie oczekujące na płatność. Kliknij Potwierdź, aby przejść do mojej strony danych！"
        },
    
        // confirm page
        confirm: {
          title: 'Potwierdzenie zamówienia',
          real_pay_amount: 'Kwota zapłacona',
          online_payment: 'Płatność online',
          create_order_error: 'Konfiguracja nie powiodła się'
        }
      },
      pay: {
        // result page
        result: {
          loading_order_status: 'Uzyskanie statusu zamówienia…',
          buy_success: 'Zamów zakończone',
          buy_pending: 'Oczekujące potwierdzenie',
          buy_pending_tip: 'Płatność w procesie… jeśli płatność nie została przeniesiona w ciągu 10 minut, skontaktuj się z nami w celu uzyskania pomocy.',
          get_payment_info_fail: 'Przejęcie informacji o płatności nie powiodło się',
          cell_package: 'Pakiet',
          cell_buy_amount: 'SubTotal',
          cell_real_amount: 'Kwota zapłacona',
          go_to_order_btn: 'Przejdź do mojego pakietu',
          back_home: 'Powrót do domu',
          back_mall: 'Powrót do centrum handlowego',
          ordersn_empty: 'Zamów SN nie może być puste',
          order_search_error: 'Nieoczekiwany błąd',
          goodsName: 'Nazwa produktu'
        },
    
        //fail page
        fail: {
          payment_fail: 'Płatność nie powiodła się',
          back_home: 'Powrót do domu'
        }
      },
      CountryGroup: {
        title: "Kraj/region",
        placeholder: "Kraj przeszukania lub regionu",
        clear: "Jasne",
        history: "Historia wyszukiwania"
      },
      PromotionCode: {
        verification: {
          title: 'Kod kuponu',
          minititle: 'Kod kuponu',
          input: 'Wprowadź kod doładowania',
          explain: 'Wskazówki: Dotknij przycisku skanowania w prawym górnym rogu, aby zeskanować kod QR karty kuponu lub ręcznie wprowadzić kod kuponu (wrażliwy na obudowę), jeśli nie działa.',
          submit: 'Składać',
          exchange: 'Odkupić',
          cancel: 'Anulować',
          Inquiry: "Czy na pewno wymieniasz",
          ErrorCode: 'Błąd naładowania kodu',
        },
        recharge_success: {
          package: 'Pakiet',
          content: 'Pomyślnie odkupiony',
          back: 'Powrót do centrum handlowego',
          view_packets: 'Przejdź do mojego pakietu'
        }
      },
      order: {
        state: {
          inUse: 'Aktywowany',
          isFirst: 'Priorytetowe',
          toFirst: 'Ustaw priorytet',
          inactive: 'Inaktywowane' 
        },
        periodUnits: {
          minute: 'protokół)',
          hour: 'godziny (s)',
          day: 'dni)',
          month: 'miesiące)',
        },
        useIntro: {
          tip1: 'Nieograniczony pakiet danych ma wyższy priorytet niż pakiet danych woluminowych;',
          tip2: 'Priorytet użytkowania będzie oparty na dacie zakupu dla tego samego rodzaju pakietu, tj. Pakiet z najwcześniejszą datą zakupu zostanie najpierw zużyty, podczas gdy priorytet pakietów jednregionów jest wyższy niż pakiet regionalny;',
          tip3: 'Możesz także ręcznie dostosować priorytet używania pakietów tego samego typu.'
        },
        myFlow: 'Moje dane',
        remainingFlow: 'Dane pozostały',
        remainingTime: 'Ważny lewy',
        remainingHighFlow: 'Pozostały dane szybkie',
        validPeriod: 'Ważność',
        noneFlow: 'Brak pakietu danych',
        noneFlowTip: 'Kup pakiet danych i ciesz się wysokiej jakości sieci',
        buyPackFlow: 'Kupić pakiety',
        checkInvalidFlow: 'Sprawdź pakiet wygasłego danych',
        orderList: {
          "title": "moje rozkazy",
          "amount_paid": "Całkowity",
          "device": "Posiadane urządzenie",
          "order_details": "Szczegóły zamówienia",
          "total_amont": "Suma częściowa",
          "orderSN": "Nr zamówienia",
          "createTime": "Czas stworzenia",
          "cancelTime": "Czas zamknięty",
          "payTime": "Czas zamówienia",
          "unsubTime": "Anulowany czas",
          "payMethod": "Metoda płatności",
          "thirdSN": "Nr transakcji",
          "delete": "Usuwać",
          "cancel": "Anuluj zamówienie",
          "unsub": "Refundacja",
          "goto_cancel": "Czy chcesz anulować zamówienie?",
          "goto_unsubscribe": "Chcesz zrezygnować z zamówienia?",
          "delete_Tips": "Po usunięciu zamówienia nie można wznowić, dlatego nie można zająć się problemami posprzedażowymi.Czy na pewno chcesz to usunąć?",
          "status_success": "Zakończony",
          "status_pending": "Nie zapłacony",
          "status_cancel": "Zamknięte",
          "status_unsub": "Odwołany",
          "payMethod_stripe": "Karta kredytowa"
        }
      },
      registerlogin: { 
        create_account_tip:"Utwórz konto, rozpocznij ekskluzywne doświadczenie",
        select_country_tip:"Używanie urządzenia kraj/region",
        email_name: 'Poczta',
        phone_name: 'Telefon',
        email_address: 'Adres e-mail',
        password: 'hasło',
        country: 'kraj',
        select_country: 'Wybierz kraj',
        cancel: 'Anulować',
        confirm: 'Jasne',
        please_enter: 'Wpisz 6-20 znaków (kombinacja liter, cyfr lub symboli)',
        select_country_tips: 'Wybór kraju służy do przeglądania lokalnych pakietów.Nie można go zmienić po rejestracji.Prosimy o potwierdzenie!',
        global_roaming: 'Międzynarodowy kod domeny',
        phone_number: 'numer telefonu',
        agree: 'zgadzać się',
        user_agreement: 'Umowa użytkownika',
        and: 'I',
        privacy_policy: 'Polityka prywatności',
        register_login: 'Zarejestruj się lub zaloguj się',
        login_error: "Liczba login jest zbyt częsta, spróbuj ponownie później!",
        register_error: "Liczba rejestracji jest zbyt częsta, spróbuj ponownie później!",
        forgot_pwd: 'Zapomnij o hasło',
        app_tips: 'Zaloguj się do aplikacji za pomocą tego konta po pobraniu go, aby uzyskać dostęp do większej liczby funkcji.',
        download_app:'Przejdź do pobrania aplikacji',
        rememberPwd: 'Pamiętaj hasło',
        third_login: "Kontynuuj z",
        agreement_tips: "Sprawdź pole Polityki Użytkownicy i Polityka prywatności",
        selectCountry_tips: "Prosimy o uprzejmie, że zarejestrowany kraj wpłynie bezpośrednio na następujące metody płatności i waluty, wybierz zgodnie z potrzebami.",
        login_error_cancel: "Użytkownik anulował logowanie",
        login_error_auth: "Zezwól na wyskakujące okna w ustawieniach przeglądarki",
        device_tips: "Urządzenie oczekuje aktywacji. Przetwarzanie w 24 godziny."
      },
      forgotPwd: {
        forgot_pwd: 'Zapomnij o hasło',
        email_address: 'Adres e-mail',
        next: 'Następny',
        email_has_been_sent: 'Wysłaliśmy wiadomość e-mail na adres %@email. Kliknij link i wykonaj kroki, aby odzyskać hasło.',
        have_retrieved_it: 'Znalazłem to',
        unable_to_receive_email: 'Nie możesz odebrać wiadomości e-mail? Sprawdź, czy w katalogu spamu i usuniętych wiadomości znajdują się wiadomości e-mail od %@email.',
        or: 'Lub',
        resend: 'Ponownie',
        global_roaming: 'Międzynarodowy kod domeny',
        phone_number: 'numer telefonu',
        verification_code_has_been_sent: 'Wysłaliśmy kod weryfikacji na:',
        verification_code: 'Kod weryfikacyjny',
        no_verification_code_received: 'Nie otrzymałeś kodu weryfikacji?',
        please_enter: 'Wpisz 6-20 znaków (kombinacja liter, cyfr lub symboli)',
        reset_password: 'Zresetuj hasło',
        reset_successful: 'Zresetować pomyślnie',
      },
      coupons: {
        coupons_name: 'Kupony',
        no_coupons: 'Nie ma jeszcze kuponów',
        no_data: 'Nie ma jeszcze danych',
        applicable_to_the_following:'Kupony są odpowiednie dla następującego pakietu danych'
      },
      digital: {
        title: "Urządzenie Sn",
        purchased: "Moje zakupy",
        viewAll: "Więcej",
        skinStore: "Sklep z produktami",
        completed: "Kupiony",
        goBuy: "Kupić",
        order: {
            title: "Zakupione zamówienia"
        },
        detail: {
            describe: "Opis"
        }
      },
      viewPL: {
        other: 'inne'
      },
      invalidFlow: {
        stateName: 'Status',
        state: {
          NOT_ACTIVATED: "Inaktywowane",
          IN_USING: "Dostępny",
          USE_END: "Wyczerpany",
          EXPIRE: "Wygasły",
          TRANSFER: "Przenosić",
          UNSUBSCRIBE: "Anulować",
          VALID: "Ważny",
          INVALID: "Nieważny",
          EXCHANGE_POINTS: "Wykup punkty"
        },
        noneFlow: 'Brak pakietu danych wygasłego',
        pageName: 'Wygasły pakiet danych'
      },
      flowDetail: {
        title: 'Szczegóły danych',
        flow: 'Dane',
        validTime: 'Ważne start',
        invalidTime: 'Ważne do',
        coverage: 'Zasięg',
        useIntro: 'Warunki',
        purchaseTime: 'Zakupiony w',
        subtotal: 'SubTotal',
        status: 'Status',
        cancel: 'Anulować',
        buyAgain: 'Kup ponownie',
        validity: 'Ważność',
        tip: 'Ogłoszenie',
        cancelTip: 'Czy na pewno chcesz zwrócić ten pakiet?',
        dataLeft: 'Dane pozostały'
      },
      netError: {
        try_again: 'Spróbuj ponownie',
        net_error: 'Brak sieci',
        try_again_desc: 'Sprawdź ustawienie sieci i spróbuj ponownie'
      },
      loadFail: {
        try_again: 'Spróbuj ponownie',
        load_fail: 'Ładowanie nie powiodło się',
        load_fail_desc: 'Ładowanie danych nie powiodło się, spróbuj ponownie',
        IMEI_Not_Exist: 'IMEI nie istnieje, spróbuj wejść z prawego wejścia',
        Project_Not_Exist:'Wystąpił błąd. Prosimy o kontakt z obsługą klienta. (01)',
        commonError:'Wystąpił błąd. Skontaktuj się z obsługą klienta.',
      },
      settlement_Easy_and_convenient:"Łatwe i wygodne",
      settlement_Great_deal:"Świetna",
      settlement_Safe_and_secure:"Bezpieczne",
      settlement_Autopay_service_regulation:"Regulacja usługi autopay",
      settlement_Read:"Czytać",
      settlement_No_coupon:"Brak dostępnego kuponu",
      settlement_Subtotal:"SubTotal",
      settlement_Coupon:"Kupon",
      settlement_TOTAL:"Całkowity",
      settlement_promotion_tip:"Oferty promocyjnej nie może być używana w połączeniu z żadnymi kuponami",
      settlement_coupon_tip:"Kuponu nie można użyć w połączeniu z żadnymi innymi ofertami promocyjnymi",
      member_myFlow_noList:"Brak danych",
      detail_se_content:"Bezpieczny, łatwy i wygodny sposób. Możesz zrezygnować z subskrypcji w dowolnym momencie",
      Enter_Promo_code:"Kod promocyjny",
      Enter_Promo_Coupon:"Kupony",
      settlement_Not_used_coupon:"kupon nie używany",
      settlement_Available_coupon:"Dostępny",
      settlement_Unavailable_coupon:"Nie płynny",
      please_Enter_Promo_code:"Wprowadź kod promocyjny",
      please_Select_Coupon_use: "Wybierz kupon, którego chcesz użyć.",
      Buy_Now:"Kup teraz",
      Dont_Use_Any:"Nie używaj żadnych",
      settlement_confirm:"Potwierdzać",
      settlement_tips:"Potwierdzać",
      flowDetail_unsubscribe: "Wypisz się",
      flowDetail_unsubscribed: "Niezgłoszone",
      flowDetail_isCancelPackage: "Zrezygnować z subskrypcji tego pakietu?",
      flowDetail_confirmAgreementUnsubscribe : "Nie możesz mieć świetnej oferty po rezygnacji z subskrypcji. Czy na pewno chcesz zrezygnować z subskrypcji?",
      flowDetail_cancel: "Anulować",
      flowDetail_cancelSuccess: "Rozpisz się pomyślnie",
      packages_detail_promotion:"Promocja",
      orderTips:{
        "iDay" : "dzień",
        "iDays" : "dni",
        "iMonth" : "miesiąc",
        "iMonths" : "miesiące",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Na pierwszym zakupie, Pay %@money/%@periodSymbol później, Możesz zrezygnować z subskrypcji w dowolnym momencie",
        'Monthly_discount':"Zapisz %@saveMoney każdy %@period! Możesz zrezygnować z subskrypcji w dowolnym momencie",
        'Ordinary_monthly_package':"Bezpieczny, łatwy i wygodny sposób.Możesz zrezygnować z subskrypcji w dowolnym momencie",
        "AlreadyPurchased":'Przepraszamy, że możesz w tej chwili subskrybować tylko jeden pakiet danych.Odejmij subskrypcję z “%@” i zapisz się później do dowolnego pakietu, którego pragniesz po wygaśnięciu.',
        "Contract_recommendation_First":'<label>Z Autopay Service, za pierwszym zakupem, płacisz tylko</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Możesz zrezygnować z subskrypcji w dowolnym momencie'
        +'<a class="btn">Subskrybować ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Dzięki usłudze autopay, płacić tylko</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Możesz zrezygnować z subskrypcji w dowolnym momencie'
        +'<a class="btn">Subskrybować ></a></p>',
        "Contract_recommendation_General":"<label>Z Autopay Service</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Bezpieczny, łatwy i wygodny sposób.Możesz zrezygnować z subskrypcji w dowolnym momencie'
        +'<a href="javascript:;" class="btn">Subskrybować ></a></p>',
        'BanlanceDoubleCheck':'Czy na pewno chcesz zapłacić saldo?',
    },
    feedback: {
      title: "informacja zwrotna",
      placeholder: "Wprowadź kraj, który chcesz odwiedzić lub inne pytania, a my spełnimy Twoje potrzeby tak szybko, jak to możliwe!",
      submit: "Złożyć",
      submit_success: "Przesłano pomyślnie",
      other_opinions: "Inne opinie",
    },
    view_country_input: 'Proszę wejść na swoje konto',
    select_package: {
      title: "Wybierz Dane",
      allPackage: 'Wszystkie Dane',
      type: "Typ",
      flow: "Dane",
      month_package: "Plan Miesięczny",
      flow_package: "Pakiet Danych",
      time: "Czas trwania",
      period: "Cykl",
      auto_debit: "Info Autodebet",
      auto_subscribe: "Auto-Odnowienie",
      detail: "Szczegóły Danych",
      carrier: "Wspierane Operatory",
      country: "Kraje Objęte",
      notice: "Przewodnik Zakupowy"
    }
}